var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCbIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157,
    height: 45,
    viewBox: "0 0 157 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6900",
    "data-name": "Group 6900",
    transform: "translate(-1280 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CB",
    transform: "translate(360 -134.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1769",
    "data-name": "Rectangle 1769",
    transform: "translate(920 518.53)",
    fill: "#fff",
    stroke: "#c3c3c3",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 45,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 72,
    height: 44,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "visa",
    transform: "translate(927.93 532.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15132",
    "data-name": "Path 15132",
    d: "M184.8,196.726l2.9-16.326h4.535l-2.812,16.326Z",
    transform: "translate(-163.848 -179.856)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15133",
    "data-name": "Path 15133",
    d: "M184.8,196.726l3.719-16.326h3.719l-2.812,16.326Z",
    transform: "translate(-163.848 -179.856)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15134",
    "data-name": "Path 15134",
    d: "M261.877,176.326a11.5,11.5,0,0,0-4.172-.726c-4.535,0-7.8,2.268-7.8,5.533,0,2.449,2.268,3.719,4.081,4.535s2.358,1.36,2.358,2.086c0,1.088-1.451,1.633-2.721,1.633a9.858,9.858,0,0,1-4.354-.907l-.635-.272L248,191.926a14.707,14.707,0,0,0,5.17.907c4.807,0,7.982-2.268,7.982-5.714,0-1.9-1.179-3.356-3.9-4.535-1.633-.816-2.63-1.27-2.63-2.086,0-.726.816-1.451,2.63-1.451a8.319,8.319,0,0,1,3.447.635l.453.181.726-3.537Z",
    transform: "translate(-219.883 -175.6)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15135",
    "data-name": "Path 15135",
    d: "M261.877,176.326a11.5,11.5,0,0,0-4.172-.726c-4.535,0-6.984,2.268-6.984,5.533,0,2.449,1.451,3.719,3.265,4.535s2.358,1.36,2.358,2.086c0,1.088-1.451,1.633-2.721,1.633a9.858,9.858,0,0,1-4.354-.907l-.635-.272L248,191.926a14.707,14.707,0,0,0,5.17.907c4.807,0,7.982-2.268,7.982-5.714,0-1.9-1.179-3.356-3.9-4.535-1.633-.816-2.63-1.27-2.63-2.086,0-.726.816-1.451,2.63-1.451a8.319,8.319,0,0,1,3.447.635l.453.181.726-3.537Z",
    transform: "translate(-219.883 -175.6)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15136",
    "data-name": "Path 15136",
    d: "M367.561,180.4c-1.088,0-1.9.091-2.358,1.179l-6.8,15.147h4.9l.907-2.721h5.8l.544,2.721h4.354L371.1,180.4Zm-2.086,10.884c.272-.816,1.814-4.807,1.814-4.807s.363-1,.635-1.633l.272,1.542s.907,4.082,1.088,4.988h-3.809Z",
    transform: "translate(-317.766 -179.856)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15137",
    "data-name": "Path 15137",
    d: "M368.649,180.4c-1.088,0-1.9.091-2.358,1.179L358.4,196.726h4.9l.907-2.721h5.8l.544,2.721h4.354L371.1,180.4Zm-3.174,10.884c.363-.907,1.814-4.807,1.814-4.807s.363-1,.635-1.633l.272,1.542s.907,4.082,1.088,4.988h-3.809Z",
    transform: "translate(-317.766 -179.856)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15138",
    "data-name": "Path 15138",
    d: "M58,192.538l-.454-2.358a13.148,13.148,0,0,0-6.349-7.165l4.081,14.512h4.9L67.526,181.2h-4.9Z",
    transform: "translate(-45.395 -180.565)",
    fill: "#3c58bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15139",
    "data-name": "Path 15139",
    d: "M58,192.538l-.454-2.358a13.148,13.148,0,0,0-6.349-7.165l4.081,14.512h4.9L67.526,181.2H63.535Z",
    transform: "translate(-45.395 -180.565)",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15140",
    "data-name": "Path 15140",
    d: "M0,180.4l.816.181c5.8,1.361,9.8,4.807,11.338,8.889l-1.633-7.71c-.272-1.088-1.088-1.361-2.086-1.361Z",
    transform: "translate(0 -179.856)",
    fill: "#ffbc00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15141",
    "data-name": "Path 15141",
    d: "M0,180.4H0c5.8,1.361,10.612,4.9,12.154,8.979l-1.542-6.44a2.214,2.214,0,0,0-2.177-1.723Z",
    transform: "translate(0 -179.856)",
    fill: "#f7981d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15142",
    "data-name": "Path 15142",
    d: "M0,180.4H0c5.8,1.361,10.612,4.9,12.154,8.979l-1.088-3.537a3.2,3.2,0,0,0-1.9-2.63Z",
    transform: "translate(0 -179.856)",
    fill: "#ed7c00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6851",
    "data-name": "Group 6851",
    transform: "translate(5.896 2.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15143",
    "data-name": "Path 15143",
    d: "M63.247,205.47l-3.084-3.084-1.451,3.447-.363-2.268A13.148,13.148,0,0,0,52,196.4l4.082,14.512h4.9Z",
    transform: "translate(-52 -196.4)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15144",
    "data-name": "Path 15144",
    d: "M189.426,293.191l-3.9-3.991-.726,3.991Z",
    transform: "translate(-169.744 -278.679)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15145",
    "data-name": "Path 15145",
    d: "M255.891,274.8h0c.363.363.544.635.454,1,0,1.088-1.451,1.633-2.721,1.633a9.859,9.859,0,0,1-4.354-.907l-.635-.272L248,279.97a14.707,14.707,0,0,0,5.17.907c2.9,0,5.261-.816,6.621-2.268Z",
    transform: "translate(-225.778 -265.911)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15146",
    "data-name": "Path 15146",
    d: "M364,231.482h4.263l.907-2.721h5.8l.544,2.721h4.354l-1.542-6.621-5.442-5.261.272,1.451s.907,4.082,1.088,4.988H370.44c.363-.907,1.814-4.807,1.814-4.807s.363-1,.635-1.633",
    transform: "translate(-328.627 -216.97)",
    fill: "#051244"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "CB-2",
    "data-name": "CB",
    transform: "translate(444 -134.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1769-2",
    "data-name": "Rectangle 1769",
    transform: "translate(920 518.53)",
    fill: "#fff",
    stroke: "#c3c3c3",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 45,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 72,
    height: 44,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mastercard_logo",
    transform: "translate(919.906 516.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15148",
    "data-name": "Path 15148",
    d: "M39.237,54.49A15.977,15.977,0,1,0,23.256,38.509,15.982,15.982,0,0,0,39.237,54.49Z",
    transform: "translate(-14.261 -13.665)",
    fill: "#e2001a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15149",
    "data-name": "Path 15149",
    d: "M268.333,54.49A15.977,15.977,0,1,0,252.36,38.509,15.982,15.982,0,0,0,268.333,54.49Z",
    transform: "translate(-220.114 -13.665)",
    fill: "#f6a800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15150",
    "data-name": "Path 15150",
    d: "M256.7,94.69a16,16,0,0,1-.08-21.826h0l.336.175h0a15.973,15.973,0,0,1-.029,21.417h0l-.227.234Z",
    transform: "translate(-220.114 -58.885)",
    fill: "#eb690a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15151",
    "data-name": "Path 15151",
    d: "M54.144,140.472h1.4l1.79,4.465,1.6-4.465h1.476v5.948H59.259v-4.413l-1.534,4.413h-.87l-1.534-4.355v4.355H54.144Z",
    transform: "translate(-42.015 -119.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15152",
    "data-name": "Path 15152",
    d: "M165.067,158.776v-4.552h-.979v4.552Z",
    transform: "translate(-140.801 -131.988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6852",
    "data-name": "Group 6852",
    transform: "translate(29.191 20.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15153",
    "data-name": "Path 15153",
    d: "M229.126,147.132v-5.868H228.1v5.868Z",
    transform: "translate(-227.504 -141.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15154",
    "data-name": "Path 15154",
    d: "M222.264,154.224v1.089h2.294v-1.089Z",
    transform: "translate(-222.264 -152.909)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15155",
    "data-name": "Path 15155",
    d: "M442.771,158.776v-4.552h-.979v4.552Z",
    transform: "translate(-390.321 -131.988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15156",
    "data-name": "Path 15156",
    d: "M529.891,148.684v-5.692h-.979v5.692Z",
    transform: "translate(-468.6 -121.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15157",
    "data-name": "Path 15157",
    d: "M311.048,153.964h-1.016v4.552h1.03v-3.011h0a1.385,1.385,0,0,1,1.081-.592h0v-.979h0c-.241,0-1.067.183-1.1.628h0v-.6Z",
    transform: "translate(-271.933 -131.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15158",
    "data-name": "Path 15158",
    d: "M464.415,153.964h-1.023v4.552h1.038v-3.011h0a1.374,1.374,0,0,1,1.074-.592h0v-.979h0c-.234,0-1.06.183-1.089.628h0v-.6Z",
    transform: "translate(-409.729 -131.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15159",
    "data-name": "Path 15159",
    d: "M186.25,155.654h1a1.22,1.22,0,0,0-1.352-1.286,1.347,1.347,0,0,0-1.505,1.418c0,.979,1.03,1.118,1.2,1.162.2.058.767.124.767.745,0,.234-.278.292-.519.292a.469.469,0,0,1-.475-.453h-1.118a1.424,1.424,0,0,0,1.593,1.432,1.54,1.54,0,0,0,1.556-1.418,1.456,1.456,0,0,0-1.33-1.293c-.884-.124-.8-.891-.285-.891.482,0,.453.212.468.292Z",
    transform: "translate(-158.915 -132.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15160",
    "data-name": "Path 15160",
    d: "M343.494,144.789a1.977,1.977,0,1,1-1.556-3.193,1.962,1.962,0,0,1,1.542.738h1.286a3.055,3.055,0,0,0-2.828-1.863,3.1,3.1,0,1,0,0,6.2,3.136,3.136,0,0,0,2.85-1.885h-1.293Z",
    transform: "translate(-297.81 -119.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15164",
    "data-name": "Path 15164",
    d: "M494.351,158.173a2.371,2.371,0,1,0,0-4.742v1.008a1.363,1.363,0,1,1,0,2.726Zm0,0h0v-1.008h0a1.363,1.363,0,1,1,0-2.726h0v-1.008h0a2.371,2.371,0,1,0,0,4.742Z",
    transform: "translate(-435.412 -131.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15165",
    "data-name": "Path 15165",
    d: "M407.231,158.173a2.371,2.371,0,1,0,0-4.742h0v1.008h0a1.363,1.363,0,1,1,0,2.726h0v1.008Zm0-4.742a2.371,2.371,0,1,0,0,4.742v-1.008a1.363,1.363,0,1,1,0-2.726Z",
    transform: "translate(-357.134 -131.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15166",
    "data-name": "Path 15166",
    d: "M255.4,156.856h2.316a1.935,1.935,0,0,0,.015-.2v-.2a2.316,2.316,0,0,0-2.331-2.375v1.1c.555,0,1.1.256,1.1.76h-1.1v.913Zm0,1.915c.921-.015,2.214-.614,2.214-1.381h-1.235c0,.183-.475.351-.979.344Zm-1.133-1.915H255.4v-.913h-1.1c0-.5.548-.76,1.1-.76v-1.1h-.029a2.313,2.313,0,0,0-2.287,2.426v.044a2.151,2.151,0,0,0,2.273,2.221h.044v-1.038c-.555-.007-1.133-.234-1.133-.877Z",
    transform: "translate(-220.761 -131.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15167",
    "data-name": "Path 15167",
    d: "M129.6,158.173a2.371,2.371,0,1,0,0-4.742v1.008a1.363,1.363,0,1,1,0,2.726Zm0,0h0v-1.008h0a1.363,1.363,0,1,1,0-2.726h0v-1.008h0a2.371,2.371,0,1,0,0,4.742Z",
    transform: "translate(-107.678 -131.275)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbIcons);
export default __webpack_public_path__ + "static/media/cb-icons.9424850f.svg";
export { ForwardRef as ReactComponent };